/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "@/api/axios";
import { ProjectLead as Lead, Project } from "../project-listing/types";
import { addAllLeadsToCRM } from "../project-listing/services/ProjectService";
import {
  LocationData,
  ProjectClass,
  ProjectStatus,
  ProjectType,
  ProjectValueOption,
} from "../project-listing/ui/topbar/type";
import { Range } from "react-date-range";
import { RootState } from "@/store";

// import { FilterPayload } from "../project-listing/ui/topbar/type";

export type MapStyle = "automatic" | "satellite" | "street" | "outdoor";

export type MarkerType = {
  id: number;
  longitude: number;
  latitude: number;
  project_type_id: [number, string];
  project_status_id: [number, string];
  starred: boolean;
  project_class_id: [number, string];
  pin_color?: string;
};
export interface PinDescription {
  title: string;
  rows: {
    subTitle: string;
    pin_color: string;
  }[];
}

export type TypeMapPins = Array<MarkerType>;

const initialMap = {
  mapState: {
    longitude: -119.35,
    latitude: 50.23,
    zoom: 10.6,
    pitch: 20,
    bearing: 0,
    speed: 1.2,
    popupAnchor: "bottom" as "top" | "bottom" | "left" | "right", // Default anchor
    popupOffset: [0, -20] as [number, number], // Default offset
  },
  mapStyle: "automatic" as MapStyle,
  selectedMarker: null as MarkerType | null,
  markerLeadDetails: [] as Lead[] | null,
  projects: [] as Array<Project>,
  leads: [] as Array<Lead>,
  lead_ids: [] as Array<number>,
  page: 1,
  nextPage: NaN,
  limit: 20,
  totalCount: NaN,
  selectedLeadIds: [] as Array<number>,
  filterBody: {
    filters: {},
  } as { filters?: any; saveFilterId?: number },
  mapPins: [] as TypeMapPins,
  userCords: {} as { latitude: number; longitude: number },
  searchString: "" as string | undefined,
  pinDescription: {} as PinDescription,
  leadLocationFilters: {
    states: [] as Array<LocationData>,
    regions: [] as Array<LocationData>,
    counties: [] as Array<LocationData>,
    cities: [] as Array<LocationData>,
    isApplied: false as boolean,
  },
  nonCrmLeadsFilterActive: false,
  leadTypeFilters: {
    statuses: [] as Array<ProjectStatus>,
    classes: [] as Array<ProjectClass>,
    types: [] as Array<ProjectType>,
    isApplied: false as boolean,
  },
  leadDateFilters: {
    tabRanges: {} as Record<string, Range | undefined>,
    isApplied: false as boolean,
  },
  leadValueFilters: {
    priceRange: [] as Array<ProjectValueOption>,
    isApplied: false as boolean,
  },
  leadBuilderFilters: {
    min: null as number | null,
    max: null as number | null,
    isApplied: false as boolean,
  },
  leadOtherFilters: {
    phone_numbers: false as boolean,
    new_projects: false as boolean,
    isApplied: false as boolean,
  },
  leadSavedFilters: {
    id: null as number | null,
    name: "" as string,
  },
};

export type PARAMS_GET_PROJECT_LEADS = {
  page: number;
  limit: number;
  view: "map" | "list";
  sortBy: string;
  sortOrder: "asc" | "desc";
};

export const getProjectLeads = createAsyncThunk(
  "project_map/getProjectLeads",
  async ({
    params,
    body,
  }: {
    params: Partial<PARAMS_GET_PROJECT_LEADS>;
    body: object;
  }) => {
    console.log("get project leads", params, body);

    if (!params?.page) {
      params.page = initialMap.page;
    }
    if (!params?.limit) {
      params.limit = initialMap.limit;
    }
    if (params?.view) {
      // params.limit = initialMap.limit;
      delete params.view;
    }

    try {
      const response = await axiosInstance({
        method: "POST",
        url: "/odoo/api/v1/projectLeads/fetch/v2",
        params: params,
        data: body,
      });

      console.log("response", response);

      const data = response.data.data as {
        // projects: Project[];
        projectLeads: Lead[];
        lead_ids: number[];
        nextPage: number;
        totalCount: number;
      };

      // leads = leads.map((l) => {
      //   return { ...l, image_url: getImage() };
      // });

      console.log("leads data", data);
      return data;
    } catch (err) {
      console.log("err", err);
    }
  }
);

export const getMapPins = createAsyncThunk(
  "project_map/getMapPins",
  async ({
    params,
    body,
  }: {
    params: Partial<PARAMS_GET_PROJECT_LEADS>;
    body: object;
  }) => {
    try {
      const response = await axiosInstance({
        method: "POST",
        url: "/odoo/api/v1/projectLeads/fetch/pins",
        params: params,
        data: body,
      });

      console.log("response", response);

      const data = response.data.data as {
        // projects: Project[];
        projectLeads: Lead[];
        lead_ids: number[];
        nextPage: number;
        totalCount: number;
        pinDescription: PinDescription;
      };

      console.log("leads data", data);
      return data;
    } catch (err) {
      console.log("err", err);
    }
  }
);

export const getPinDetails = createAsyncThunk(
  "project_map/getPinDetails",
  async ({ params }: { params: { id: number } }) => {
    try {
      const response = await axiosInstance({
        method: "GET",
        url: "/odoo/api/v1/projectLeads/fetch/pins/details",
        params: params,
      });

      console.log("response", response);

      const data = response.data.data as Lead;

      console.log("leads data", data);
      return data;
    } catch (err) {
      console.log("err", err);
    }
  }
);

export const saveProjectLead = createAsyncThunk(
  "project_map/saveProjectLead",
  async (data: object) => {
    // console.log("get project leads", params, data);
    try {
      const response = await axiosInstance({
        method: "POST",
        url: "/odoo/api/v1/projectLeads/save",
        // params: params,
        // data: data,
        data: data,
      });

      console.log("response", response);

      return {
        response: response.data,
        data: data,
      };
    } catch (err) {
      console.log("err", err);
    }
  }
);

export const saveMultipleProjectLead = createAsyncThunk(
  "project_map/saveMultipleProjectLead",
  addAllLeadsToCRM
);

export const saveFilter = async (data: object) => {
  // console.log("get project leads", params, data);
  try {
    const response = await axiosInstance({
      method: "POST",
      url: "/odoo/api/v1/projectLeads/filters/v2",
      data: data,
    });
    console.log("response", response);
    return response;
  } catch (err) {
    console.log("err", err);
  }
};

export const deleteFilter = async (data: { filterId: number }) => {
  // console.log("get project leads", params, data);
  try {
    const response = await axiosInstance({
      method: "POST",
      url: "/odoo/api/v1/projectLeads/filters/delete",
      data: data,
    });
    console.log("response", response);
    return response;
  } catch (err) {
    console.log("err", err);
  }
};

export const setFlagLead = createAsyncThunk(
  "project_map/setFlagLead",
  async (data: object) => {
    // console.log("get project leads", params, data);
    try {
      const response = await axiosInstance({
        method: "PUT",
        url: "/odoo/api/v1/projectLeads/flags",
        // params: params,
        // data: data,
        data: data,
      });

      console.log("response", response);

      return response;
    } catch (err) {
      console.log("err", err);
    }
  }
);

const mapSlice = createSlice({
  name: "project_map",
  initialState: initialMap,
  reducers: {
    setMapState: (state, action) => {
      state.mapState = {
        ...state.mapState,
        ...action.payload,
        latitude: action.payload.latitude ?? state.mapState.latitude, //  Agar latitude nahi mila toh purana use karo
        longitude: action.payload.longitude ?? state.mapState.longitude, //  Agar longitude nahi mila toh purana use karo
      };
    },
    setMapStyle: (state, action) => {
      state.mapStyle = action.payload;
    },
    setSelectedMarker: (state, action) => {
      state.selectedMarker = action.payload;
    },
    setPinDetails: (state, action) => {
      state.markerLeadDetails = action.payload;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setNextPage: (state, action) => {
      state.nextPage = action.payload;
    },
    setLimit: (state, action) => {
      state.limit = action.payload;
    },
    setSelectedLeadIds: (state, action) => {
      state.selectedLeadIds = action.payload;
    },
    setFilterBody: (state, action) => {
      state.filterBody = action.payload;
    },
    clearFilterBody: (state) => {
      state.filterBody = {
        filters: {},
      };
    },
    setUserCords: (state, action) => {
      state.userCords = action.payload;
    },
    setSearchString: (state, action) => {
      state.searchString = action.payload;
    },
    setPinDescription: (state, action) => {
      state.pinDescription = action.payload;
    },
    setLeadLocationFilters: (state, action) => {
      state.leadLocationFilters = action.payload;
    },
    setLeadTypeFilters: (state, action) => {
      state.leadTypeFilters = action.payload;
    },
    setLeadDateFilters: (state, action) => {
      state.leadDateFilters = action.payload;
    },
    setLeadValueFilters: (state, action) => {
      state.leadValueFilters = action.payload;
    },
    setLeadBuilderFilters: (state, action) => {
      state.leadBuilderFilters = action.payload;
    },
    setLeadOtherFilters: (state, action) => {
      state.leadOtherFilters = action.payload;
    },
    setLeadSavedFilters: (state, action) => {
      state.leadSavedFilters = action.payload;
    },
    // setNonCrmLeadsFilter: (state, action) => {
    //   state.nonCrmLeadsfilter = action.payload;
    // },
    toggleNonCrmLeadsFilter: (state) => {
      state.nonCrmLeadsFilterActive = !state.nonCrmLeadsFilterActive;
      state.filterBody.filters.not_saved_in_crm = state.nonCrmLeadsFilterActive;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getProjectLeads.fulfilled, (state, action) => {
        if (action.payload) {
          if (state.page == 1) {
            state.leads = action.payload?.projectLeads as Lead[];

            if (state.leads.length === 0) {
              state.leads = [];
            }

            const p1 = action.payload.projectLeads[0];

            if (p1) {
              // Ensure p1 exists before accessing latitude/longitude
              const lat =
                typeof p1.latitude == "number"
                  ? p1.latitude
                  : state.mapState.latitude;
              const lng =
                typeof p1.longitude == "number"
                  ? p1.longitude
                  : state.mapState.longitude;
              const cords = { latitude: lat, longitude: lng };
              state.mapState = { ...state.mapState, ...cords };
            }
          } else {
            state.leads = state.leads.concat(
              (action.payload?.projectLeads || []) as Lead[]
            );
          }
          state.nextPage = action.payload.nextPage;
          state.totalCount = action.payload.totalCount;
          if (state.leads.length > 0) {
            const leadIds = state.leads.map((l) => l.id);
            state.lead_ids = leadIds;
          }
        }
      })
      .addCase(getMapPins.fulfilled, (state, action) => {
        if (action.payload) {
          state.mapPins = action.payload?.projectLeads;
          if (action.payload?.pinDescription) {
            console.log("set pinDescription", action.payload.pinDescription);
            state.pinDescription = action.payload.pinDescription;
          }
        }
      })
      .addCase(getPinDetails.fulfilled, (state, action) => {
        if (action.payload) {
          state.markerLeadDetails = [action.payload];
        }
      })
      .addCase(saveProjectLead.fulfilled, (state, action) => {
        if (action.payload) {
          const crm_lead_id = action.payload.response?.data?.crm_lead_id;
          const leadId = (action.payload.data as any)?.leadId;
          if (crm_lead_id && leadId) {
            const columnIndex = state.leads?.findIndex(
              (item) => item.id == leadId
            );

            console.log("column index", columnIndex);
            if (columnIndex >= 0) {
              const tempLeads = [...state.leads];
              console.log("tempLeads", tempLeads);
              // const lead = { ...tempLeads[columnIndex] };
              tempLeads[columnIndex].crm_lead_id = crm_lead_id;
              tempLeads[columnIndex].starred = true;
              // tempLeads[columnIndex] = lead;
              state.leads = [...tempLeads];
            }

            if (
              state.markerLeadDetails &&
              state.markerLeadDetails[0]?.id == leadId
            ) {
              state.markerLeadDetails[0].crm_lead_id = crm_lead_id;
              state.markerLeadDetails[0].starred = true;
            }

            const pinIndex = state.mapPins?.findIndex(
              (item) => item.id == leadId
            );
            if (pinIndex >= 0) {
              const tempPins = [...state.mapPins];
              tempPins[pinIndex].starred = true;
              state.mapPins = [...tempPins];
            }
          }
          console.log("save project lead", action.payload);
        }
      })
      .addCase(saveMultipleProjectLead.fulfilled, (state, action) => {
        // const leadIds = action.payload?.leadIds;
        const crm_lead_ids = action.payload?.response?.crm_lead_ids as Array<{
          crm_lead_id: number;
          project_lead_id: number;
        }>;
        console.log("saveMultipleProjectLead", crm_lead_ids);
        // console.log("saveMultipleProjectLead", action.payload?.leadIds);
        if (crm_lead_ids && crm_lead_ids.length > 0) {
          for (const crm_prop of crm_lead_ids) {
            const crm_lead_id = crm_prop.crm_lead_id;
            const leadId = crm_prop.project_lead_id;
            if (crm_lead_id && leadId) {
              const columnIndex = state.leads?.findIndex(
                (item) => item.id == leadId
              );

              console.log("column index", columnIndex);
              if (columnIndex >= 0) {
                const tempLeads = [...state.leads];
                console.log("tempLeads", tempLeads);
                // const lead = { ...tempLeads[columnIndex] };
                tempLeads[columnIndex].crm_lead_id = crm_lead_id;
                tempLeads[columnIndex].starred = true;
                // tempLeads[columnIndex] = lead;
                state.leads = [...tempLeads];
              }

              if (
                state.markerLeadDetails &&
                state.markerLeadDetails[0]?.id == leadId
              ) {
                state.markerLeadDetails[0].crm_lead_id = crm_lead_id;
                state.markerLeadDetails[0].starred = true;
              }

              const pinIndex = state.mapPins?.findIndex(
                (item) => item.id == leadId
              );
              if (pinIndex >= 0) {
                const tempPins = [...state.mapPins];
                tempPins[pinIndex].starred = true;
                state.mapPins = [...tempPins];
              }
            }
          }
        }
      });
  },
});

// {
//   "response": {
//       "message": "Updated",
//       "statusCode": 200,
//       "data": {
//           "crm_lead_id": 154
//       }
//   },
//   "data": {
//       "leadId": 14206
//   }
// }

export const selectNonCrmLeadsFilter = (state: RootState) => 
  state.rootReducer.mapViewReducer.nonCrmLeadsFilterActive;

export const {
  setMapState,
  setMapStyle,
  setSelectedMarker,
  setPage,
  setLimit,
  setSelectedLeadIds,
  setFilterBody,
  clearFilterBody,
  setPinDetails,
  setUserCords,
  setSearchString,
  setLeadLocationFilters,
  setLeadTypeFilters,
  setLeadDateFilters,
  setLeadValueFilters,
  setLeadBuilderFilters,
  setLeadOtherFilters,
  setLeadSavedFilters,
  toggleNonCrmLeadsFilter
  // setNonCrmLeadsFilter,
} = mapSlice.actions;
export default mapSlice.reducer;
